import React from 'react';
import { PropTypes } from 'prop-types';

export default function TaskForm({ onCreate }) {
  const [name, setName] = React.useState('');

  const handleCreate = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      return;
    }
    onCreate({ name: trimmed });
    setName('');
  };

  return (
    <div>
      <input
        type="text"
        placeholder="TaskName"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input type="button" value="Save" onClick={handleCreate} />
    </div>
  );
}

TaskForm.propTypes = {
  onCreate: PropTypes.func.isRequired,
};
